var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBookmarkOutlineIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-bookmark-5753338 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.66002 13.0919L7.33306 12.8093L7.00609 13.0919L3.48887 16.132L3.48868 16.1322C3.19346 16.3876 2.77889 16.4457 2.42568 16.2825C2.07245 16.1179 1.84375 15.7603 1.84375 15.3642V2.6622C1.84375 2.1002 2.29391 1.65234 2.84108 1.65234H11.825C12.3722 1.65234 12.8224 2.1002 12.8224 2.6622V15.3642C12.8224 15.7604 12.5937 16.118 12.2404 16.2825C11.8872 16.4457 11.4727 16.3876 11.1774 16.1322L11.1772 16.132L7.66002 13.0919Z",
    fill: "white",
    stroke: "#044B7F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkOutlineIcon);
export default __webpack_public_path__ + "static/media/bookmark-outline-icon.13a3c9a838737016e2a266e9d5d45561.svg";
export { ForwardRef as ReactComponent };